import type { ReactNode } from 'react';
import { NOT_AVAILABLE } from '../policies/distance-labels.policy';

interface DistanceFigureProps {
  /** The figure as text; null when there is none. */
  value: string | null;
  /** Why there is none, shown under "Not available". */
  unavailable: string | null;
  /** A second line under a figure, such as GPS coverage. */
  note?: ReactNode;
}

/** A distance, or "Not available" with its reason: a missing distance is never shown as 0. */
export function DistanceFigure({ value, unavailable, note }: DistanceFigureProps) {
  if (value === null) {
    return (
      <span className="flex flex-col">
        <span className="text-muted">{NOT_AVAILABLE}</span>
        {unavailable && <span className="text-xs text-muted">{unavailable}</span>}
      </span>
    );
  }
  return (
    <span className="flex flex-col">
      <span className="font-medium tabular-nums">{value}</span>
      {note && <span className="text-xs text-muted">{note}</span>}
    </span>
  );
}
